import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "./contexts/CartContext";
import Home from "./pages/Home";
import PlanVisit from "./pages/PlanVisit";
import Admin from "./pages/Admin";
import WhatWeBelieve from "./pages/WhatWeBelieve";
import Contact from "./pages/Contact";
import Give from "./pages/Give";
import Ministries from "./pages/Ministries";
import MinistryDetail from "./pages/MinistryDetail";
import Merch from "./pages/Merch";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import OrderSuccess from "./pages/OrderSuccess";

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/plan-a-visit" element={<PlanVisit />} />
            <Route path="/about/what-we-believe" element={<WhatWeBelieve />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/give" element={<Give />} />
            <Route path="/ministries" element={<Ministries />} />
            <Route path="/ministries/:slug" element={<MinistryDetail />} />
            <Route path="/merch" element={<Merch />} />
            <Route path="/merch/product/:slug" element={<ProductDetail />} />
            <Route path="/merch/cart" element={<Cart />} />
            <Route path="/merch/order/:orderId" element={<OrderSuccess />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </div>
  );
}

export default App;
